import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify.js'
import store from './store/index.js'
import VueMask from 'v-mask'
import router from './router/index.js'

Vue.config.productionTip = false
var eventBus = new Vue()
Vue.use(VueMask)

new Vue({
  vuetify,
  store,
  router,
  eventBus,
  render: h => h(App),
}).$mount('#app')
